import baseURL from '../common/axios';
class Commonservices {

    //To Insert Room-->Inventory API
    insertRoom(dataModel) {
        return baseURL.httpMSInventoryUrl.post("RoomMAS/Create", dataModel)
    }
    //To Update Room-->Inventoer API
    updateRoom(dataModel) {
        return baseURL.httpMSInventoryUrl.post("RoomMAS/Update", dataModel)
    }
    //To Delete Room-->Inventory API
    deleteRoom(Id) {
        return baseURL.httpMSInventoryUrl.delete("RoomMAS/Delete?id=" + Id)
    }
    //Active
    active(Id, Status) {
        return baseURL.httpMSInventoryUrl.put("RoomMAS/Active?id=" + Id + "&Status=" + Status + "")
    }
    //To Get Room List-->Inventory API
    getRoomList() {
        return baseURL.httpMSInventoryUrl.get("RoomMAS/List")
    }
    //To Get Room List-->Inventory API
    getRoomById(Id) {
        return baseURL.httpMSInventoryUrl.get("RoomMAS/Get?id=" + Id + "")
    }
    //To get Room List based on StoreId-->Inventory API
    getRoomByStoreId(Id,StoreBrMapId) {
        debugger;
        let startDate = "2023-02-03T11:05:31.945Z";
        let endDate = "2023-02-03T11:05:31.945Z";
        return baseURL.httpMSInventoryUrl.get("Custom/ListRoomMASByStoreMASId?ID=" + Id + "&startDate=" + startDate + "&endDate=" + endDate +"&StoreBrMapId=" +StoreBrMapId)
    }

}
export default new Commonservices()